import { FC } from "react";
import { Outlet } from "react-router-dom";

import { featureFlags } from "@settings";
import { PageLayoutV1 } from "./PageLayoutV1";
import { PageLayoutV2 } from "./PageLayoutV2";
import { IPageLayoutProps } from "./types";

export const PageLayout: FC<IPageLayoutProps> = (props) => {
  const { enableLayoutV2 } = featureFlags;

  return enableLayoutV2 ? (
    <PageLayoutV2 {...props}>
      <Outlet />
    </PageLayoutV2>
  ) : (
    <PageLayoutV1 {...props}>
      <Outlet />
    </PageLayoutV1>
  );
};
